module.exports = __webpack_public_path__ + "6bcbdbaf4a866f42d3fcc4a3974f4b98.svg";